'use client';

import { useState, useCallback } from 'react';

export const useCalculatorState = () => {
  const [formData, setFormData] = useState({
    propertyValue: '',
    initialAdvance: '',
    interestRate: '',
    annualHousePriceChange: '',
    emerald: '0.12',
    classic: '0.1',
    sovereign: '0.1',
    heritage: '0.1',
    selectedProduct: '',
    loanBalanceGraphDataWithOutPayment: [],
    loanBalanceGraphDataWithPayment: [],
    equityRemainingGraphDataWithoutPayment: [],
    equityRemainingGraphDataWithPayment: [],
    dataRemainingBalanceTable: [],
  });

  const [annualPayments, setAnnualPayments] = useState([
    { id: 1, repaymentAmount: '', yearToApplyPayment: '' },
  ]);

  const [showResults, setShowResults] = useState(false);
  const [currentTabId, setCurrentTabId] = useState('annual-overpayments-table');

  const isFormValid = formData.propertyValue
    && formData.initialAdvance
    && formData.interestRate
    && formData.annualHousePriceChange
    && formData.selectedProduct
    && annualPayments.every(payment =>
      payment.repaymentAmount && payment.yearToApplyPayment);

  const getNumericValues = useCallback(() => {
    const getValue = (val) => val ? parseFloat(val.replace(/,/g, '')) || 0 : 0;

    return {
      propertyValue: getValue(formData.propertyValue),
      initialAdvance: getValue(formData.initialAdvance),
      interestRate: getValue(formData.interestRate),
      annualHousePriceChange: getValue(formData.annualHousePriceChange),
    };
  }, [formData]);

  const handleInputChange = useCallback((name, value) => {
    setShowResults(false);
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleRadioChange = useCallback((productName) => {
    setShowResults(false);
    setFormData(prev => ({
      ...prev,
      selectedProduct: productName,
    }));
  }, []);

  const updateFormData = useCallback((updates) => {
    setFormData(prev => ({
      ...prev,
      ...updates,
    }));
  }, []);

  return {
    formData,
    annualPayments,
    setAnnualPayments,
    showResults,
    setShowResults,
    currentTabId,
    setCurrentTabId,
    isFormValid,
    getNumericValues,
    handleInputChange,
    handleRadioChange,
    updateFormData,
  };
};
